module.exports = __webpack_public_path__ + "img/DE01456.cdbe8d98.png";